export const login = (redirectUrl?: string) => {
  console.log("loginloginloginloginlogin")
  if (!redirectUrl?.startsWith("/auth/login") && redirectUrl?.startsWith("/ab")) {
    return "/ab";
  }
  return redirectUrl
    ? `/auth/login?redirect=${encodeURIComponent(redirectUrl)}`
    : "/auth/login";
};
